import PropTypes from 'prop-types';
import { useState } from "react";
import Dialog from "components/ui/Dialog/Dialog";
import { useDialog } from "context/DialogContext";
import Button from "components/ui/Button/Button";
import Loader from "components/ui/Loader/Loader";
import useData from "hooks/useData";
import Alert from "components/ui/Alert/Alert";

const BulletinDelete = ({ id, title, onCompleted }) => {
  const { hideDialog } = useDialog();
  const { deleteData } = useData();
  const [ working, setWorking ] = useState(false);
  const [ error, setError ] = useState();

  const onConfirm = async () => {
    setWorking(true);
    const result = await deleteData(`rest/bulletin/${ id }`, false);
    if (result.status === 204) {
      hideDialog();
      if (onCompleted) {
        onCompleted();
      }
    } else {
      setError(`Het verwijderen is mislukt (${ result.status })`);
    }
    setWorking(false);
  };

  return (
    <Dialog title={ `Bericht verwijderen` }>
      { error && <Alert message={ error }/> }
      { working ? <Loader/> :
        <>
          <div className={ `dialog__row` }>
            <h3>Weet u zeker dat u bericht "{ title }" wilt verwijderen?</h3>
          </div>
          <div className="dialog__buttons">
            <Button variant={ `ghost` } onClick={ () => hideDialog() }>Annuleren</Button>
            <Button variant={ `secondary` } onClick={ onConfirm }>Verwijderen</Button>
          </div>
        </>
      }
    </Dialog>
  )
}

BulletinDelete.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  onDeleted: PropTypes.func,
}

export default BulletinDelete;
